const ActionTypes = {
  GET_APPOINTMENTS: 'GET_APPOINTMENTS',
  GET_CLIENT_API_LOCATIONS: 'GET_CLIENT_API_LOCATIONS',
  GET_CLIENT_API_SOLAR: 'GET_CLIENT_API_SOLAR',
  GET_CLIENT_API_VERIFY_POTENTIAL: 'GET_CLIENT_API_VERIFY_POTENTIAL',
  GET_CLIENT_API_SLOTS: 'GET_CLIENT_API_SLOTS',
  CHECK_SUBSCRIPTION_MATCH: 'CHECK_SUBSCRIPTION_MATCH',
  CANCEL_SUBSCRIPTION_MATCH_CHECK: 'CANCEL_SUBSCRIPTION_MATCH_CHECK',
  SUBMIT_CLIENT_API_BOOKING: 'SUBMIT_CLIENT_API_BOOKING',
  REPORT_CLIENT_API_BOOKING_NOT_CONFIRMABLE:
    'REPORT_CLIENT_API_BOOKING_NOT_CONFIRMABLE',
  REFUSE_CLIENT_API_JOURNEY: 'REFUSE_CLIENT_API_JOURNEY',
  REPORT_CLIENT_API_FALL_THROUGH_OUTCOME:
    'REPORT_CLIENT_API_FALL_THROUGH_OUTCOME',
  START_CLIENT_API_INACTIVITY_TIMER: 'START_CLIENT_API_INACTIVITY_TIMER',
  STOP_CLIENT_API_INACTIVITY_TIMER: 'STOP_CLIENT_API_INACTIVITY_TIMER',
  CLIENT_API_USER_ACTIVITY: 'CLIENT_API_USER_ACTIVITY',
  CONFIRM_CLIENT_API_STILL_PRESENT: 'CONFIRM_CLIENT_API_STILL_PRESENT',
  GET_PLACE_PREDICTIONS: 'GET_PLACE_PREDICTIONS',
  GET_LEGAL_STATEMENT: 'GET_LEGAL_STATEMENT',
  GET_SUBMISSION_STATUS: 'GET_SUBMISSION_STATUS',
  GET_LEAD_STATUS: 'GET_LEAD_STATUS',
  STOP_LEAD_STATUS_POLL: 'STOP_LEAD_STATUS_POLL',
  VALIDATE_POSTCODE: 'VALIDATE_POSTCODE',
  VALIDATE_PHONE_NUMBER: 'VALIDATE_PHONE_NUMBER',
  GET_AUTOCOMPLETE_OPTIONS: 'GET_AUTOCOMPLETE_OPTIONS',
  GET_EXTERNAL_SELECT_OPTIONS: 'GET_EXTERNAL_SELECT_OPTIONS',
  GET_CUSTOMER_MATCHES: 'GET_CUSTOMER_MATCHES',
  REFRESH_MATCHING_SUPPLIER_COUNT: 'REFRESH_MATCHING_SUPPLIER_COUNT',
  PREPARE_SUPPLIER_MATCHING: 'PREPARE_SUPPLIER_MATCHING',
  GET_SUPPLIER_CARD_LOGOS: 'GET_SUPPLIER_CARD_LOGOS',
  DECRYPT_CRM_DATA: 'DECRYPT_CRM_DATA',
  SUBSCRIBE_TO_NEWSLETTER: 'SUBSCRIBE_TO_NEWSLETTER',
  IS_DOMAIN_INTERNAL: 'IS_DOMAIN_INTERNAL',
  GET_DYNAMIC_NEWSLETTER: 'GET_DYNAMIC_NEWSLETTER',
  HANDLE_ANSWER_QUESTION_SIDE_EFFECTS: 'HANDLE_ANSWER_QUESTION_SIDE_EFFECTS',
  HANDLE_ANSWER_QUESTION_SIDE_EFFECTS_COMPLETED:
    'HANDLE_ANSWER_QUESTION_SIDE_EFFECTS_COMPLETED',
  SUBMIT_SELECT_AND_CONNECT: 'SUBMIT_SELECT_AND_CONNECT',
  HANDLE_GOOGLE_ADDRESS_SELECTED: 'HANDLE_GOOGLE_ADDRESS_SELECTED',
  HANDLE_ZIP_CODE_PROVIDED: 'HANDLE_ZIP_CODE_PROVIDED',
  POPULATE_FORM_FIELD: 'POPULATE_FORM_FIELD',
};

export default ActionTypes;
